import * as React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  IconButton,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { LinkedIn } from "@mui/icons-material";
import imageIndex from "../ImageIndex";

const speakersData = [
  {
    id: 1,
    name: "Dra Bárbara Bermúdez Reyes",
    title: "Materiales Aeroespaciales y Manufactura",
    image: imageIndex.JuezDraBarbara,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/barbara-bermudez-reyes-b021396a/",
    },
    bio: "La Dra. Bárbara Bermúdez Reyes es Doctora en Ciencias de la Metalurgia y Ciencia de los Materiales y profesora en la Unidad de Alta Tecnología-Facultad de Ingeniería de la UNAM. Miembro del Sistema Nacional de Investigadores (Nivel I) desde 2012, ha sido profesora-investigadora en diversas universidades del país. Cuenta con certificaciones de Keio University y Kyushu Institute of Technology en misiones CanSat y pruebas para satélites. En 2017 fue reconocida por el CITEDI-IPN como Mujer Mexicana hacia el Espacio en el área de Ingeniería.\n\n Ha participado en concursos nacionales CanSat desde 2015, y ha sido evaluadora de proyectos para la SEDENA, la Armada de México, RCEA-SECIHTI y ENMICE. Fue secretaria general del Capítulo México de UNISEC (2014-2020). Actualmente lidera proyectos apoyados por SECIHTI, uno de los cuales recibió patente en 2022 y el Premio Estatal a la Innovación en 2023. Desde 2012 colabora en investigación sobre recubrimientos vitrocerámicos y es punto de contacto en México del World Cansat/Rocketry Championship.",
  },
  {
    id: 2,
    name: "Dra. Anne Warren Johnson",
    title: "Sostenibilidad y Social",
    image: imageIndex.JuezDraAnne,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/anne-johnson-99a2ba24",
    },
    bio: "Anne W. Johnson es Profesora-Investigadora del Posgrado en Antropología Social del Departamento de Ciencias Políticas y Sociales de la Universidad Iberoamericana, donde imparte cursos sobre ciencia y tecnología, antropología de los futuros y cultura material. Es doctora y maestra en Antropología Social por la Universidad de Texas en Austin, y tiene la licenciatura en Antropología y Artes Teatrales por la Brown University. \n\n Ha publicado en libros y revistas especializadas, nacionales e internacionales, incluyendo artículos en la Revista Colombiana de Antropología (2023) y Acta Astronautica (2021), y capítulos en los libros Space Feminisms (Routledge, 2024), The Routledge Encyclopedia of the Social Studies of Outer Space (Routledge, 2023) y Southern Space Studies (Springer, 2022). Su libro sobre los imaginarios mexicanos sobre el espacio exterior y el futuro desde perspectivas tecnocientíficas y artísticas está en prensa con la Universidad de Arizona. También ha sido integrante del Comité Evaluador de ENMICE 2023 - 2024.",
  },
  {
    id: 3,
    name: "Dra. María Guiomar Melgar Lalanne",
    title: "Cargas Biológicas",
    image: imageIndex.JuezDraMaria,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/guiomar-melgar-lalanne-98123671/",
    },
    bio: "La Dra. Guiomar es Maestra en Ciencias de los Alimentos y Doctora en Ciencias en Alimentos por la Escuela Nacional de Ciencias Biológicas del Instituto Politécnico Nacional (México). Además, tiene las licenciaturas de Ingeniería Técnica Agrícola y Ciencia y Tecnología de Alimentos. Su línea de investigación principal es la de Etnobiotecnologia alimentaria y ambiental para la salud. \n\n Actualmente es investigadora en el Instituto de Ciencias Básicas de la Universidad Veracruzana y miembro del Sistema Nacional de Investigadores (SNI) con el nivel 2. En 2019 recibió el premio al mejor protocolo de investigación en probióticos Minoru Shirota. Cuenta con más de 44 publicaciones en revistas indexadas, ha editado un libro y asesora estudiantes de doctorado, maestría y licenciatura. Coordina el Diplomado en Herramientas para la Escritura Científica de la UV y forma parte del Consejo Consultivo de la Biblioteca del Universitario de la UV. Colabora en numerosas actividades de divulgación.",
  },
  {
    id: 4,
    name: "Dr. Pablo Alejandro Arizpe Carreón",
    title: "Propulsión y Diseño de Lanzadores",
    image: imageIndex.JuezDrPablo,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/pablo-alejandro-arizpe-34674a34/",
    },
    bio: "Es graduado con honores de Ingeniería en Aeronáutica por el IPN y trabajó en mantenimiento de helicópteros en el aeropuerto de la CDMX. Gracias a una beca de posgrado de CONAHCyT (hoy SECIHTI), realizó estudios de maestría y doctorado en la Universidad Estatal de Moscú y el Instituto de Aviación de Moscú (MAI) en Rusia. Participó en la misión espacial UNAMSAT III y colaboró con la BUAP en el satélite Tatiana II. Fue director y profesor de Ingeniería Aeronáutica en la UPMH, donde fundó la Maestría en Ingeniería Aeroespacial, adscrita al Programa Nacional de Posgrados de Calidad. \n\n Desde 2014 es profesor en el IPN y actualmente coordina los Servicios Académicos del Centro de Desarrollo Aeroespacial (CDA-IPN), impulsando la movilidad internacional de más de 200 estudiantes hacia instituciones como la NASA, Rusia y Francia. Es embajador del Programa Internacional del Aire y el Espacio (IASP) de AEXA. Obtuvo el grado de Doctor en Educación en 2022 y un Doctorado Honoris Causa en 2024. \n\n Especialista en propulsión y sistemas espaciales, cuenta con certificación en la plataforma 3D Experience (CATIA) de Dassault Systèmes, es autor de cuatro libros sobre el área aeroespacial, director de tesis y conferencista nacional. Forma parte del CIMA, la Red de Expertos en Telecomunicaciones del IPN y desde 2025 es radio experimentador certificado por el IFT (XE1PAC). Entre sus proyectos destacan el diseño de aeronaves, cohetes, turbinas de gas, bancos de prueba, combustibles, sistemas satelitales y propulsión eléctrica.",
  },
  {
    id: 5,
    name: "Dr. Jhonatan Fernando Eulopa Hernández",
    title: "Cargas Útiles y Diseño de Picosatélites",
    image: imageIndex.JuezDrJhonatan,

    socialLinks: {
      linkedin: "#",
    },
    bio: "Jhonatan Fernando Eulopa Hernandez es un profesional de la Ingeniería Aeroespacial con una sólida trayectoria en diseño, análisis, investigación y gestión de proyectos complejos en la industria aeroespacial. Cuenta con experiencia en el desarrollo de nanosatélites, control de tareas aeronáuticas, sistemas de control de trayectoria para nanolanzadores, análisis estructural y liderazgo de proyectos multidisciplinarios, aportando una visión integral y estratégica en el ámbito científico y tecnológico. Ha ocupado roles como Coordinador de Fomento al Desarrollo de la Empresa - Industria Nacional, Profesor Investigador y Subdirector de Normalización y Servicios Científicos y Tecnológicos en el Centro de Desarrollo Aeroespacial (CDA) IPN. Además, es Doctor en Sistemas Autónomos de Navegación Aérea y Submarina, y tiene Maestrías en Ciencias en Ingeniería Aeronáutica y Espacial e Ingeniería en Aeronáutica del IPN. \n\n Su experiencia incluye el desarrollo de proyectos de investigación científica y tecnológica para el sector aeroespacial, formación de recursos humanos especializados, y asesoría en proyectos científicos y tecnológicos para el sector público y privado. Ha sido representante del Instituto Politécnico Nacional ante la Junta de Gobierno de la Agencia Espacial Mexicana (AEM). También ha contribuido en conferencias internacionales como miembro de comité y presidente de publicaciones. Entre sus habilidades técnicas se incluyen el dominio de software como CATIA, Autodesk Inventor Professional, ANSYS, Matlab, SolidWorks, Ardupilot y STK, y es bilingüe en Español e Inglés, con conocimientos de Francés.",
  },
  {
    id: 6,
    name: "Mtro. Víctor Manuel Quezada Navarro",
    title: "Especialista en CFD y Análisis de Datos",
    image: imageIndex.JuezMtroVictor,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/vmquezada/",
    },
    bio: "El Mtro. Víctor Manuel Quezada Navarro es un académico e investigador con más de 25 años de trayectoria en docencia e investigación aplicada a la ingeniería. Posee una Maestría en Ciencias en Ingeniería Química por la Universidad de Guadalajara, con especialidad en Mecánica de Fluidos. Realizó estudios de doctorado en Ingeniería Mecánica en la Universidad de Karlsruhe y en Ciencias Aeroespaciales en la Universidad de Stuttgart, Alemania, consolidando su perfil en modelado matemático y simulación computacional como investigador en el Centro Aeroespacial Alemán (DLR) en Stuttgart. Con gusto participa nuevamente como juez en el Encuentro Nacional de Mantenimiento e Ingeniería para la Competitividad y la Exposición (ENMICE), evento en el que ha colaborado en ediciones anteriores (2022 y 2023 - 2024). \n\n Actualmente, es profesor investigador en el Departamento de Ingeniería Mecánica de la Universidad de Guadalajara, donde se desempeña como Coordinador del Programa Educativo de Ingeniería Aeroespacial. Su labor académica incluye la formación de recursos humanos en áreas como mecánica de fluidos, termodinámica, transferencia de calor y dinámica de fluidos computacional. Ha sido responsable de proyectos de investigación aplicada y ha colaborado con diversas instituciones académicas y empresas en el desarrollo de tecnologías aeroespaciales. \n\n Ha formado a nuevas generaciones de ingenieros en diversas instituciones, y actualmente es docente en la Universidad Marista de Guadalajara en Ingeniería Aeroespacial y tutor de Termodinámica en un posgrado de la Universidad Anáhuac en línea. Su pasión por la enseñanza y curiosidad lo definen como un mentor cercano y un eterno estudiante, comprometido con la excelencia académica.",
  },
  {
    id: 7,
    name: "Ing. Ciro Zarate Tomas",
    title: "Propulsión y Operaciones de Lanzamiento",
    image: imageIndex.JuezIngCiro,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/ciro-zárate-tomás-2266b448/",
    },
    bio: "Ingeniero en Aeronáutica egresado del Instituto Politécnico Nacional, actualmente es Profesor de tiempo completo en la Licenciatura en Ingeniería Aeroespacial en la Universidad Marista de Guadalajara. En 2010, fue encargado del diseño y construcción de generadores de humo para aviones Pilatus PC-7 de la Fuerza Aérea Mexicana. Ha colaborado en el diseño y construcción de partes aeronáuticas como pernos para tren de aterrizaje de aviones Aravá y la reparación estructural del avión 737-200 de la Fuerza Aérea Mexicana. \n\n También ha participado en la Subdirección General de Industria Aeronáutica Militar como encargado del proyecto de desarrollo de un prototipo de cohete de práctica aire-tierra y su lanzador, en colaboración con el Instituto Politécnico Nacional. Ha sido asesor en los eventos SAE Aerodesign y Encuentro Mexicano de Ingeniería en Cohetería Experimental (ENMICE) para el desarrollo de tecnología aeroespacial. Actualmente, es encargado del taller de cohetería experimental en la Universidad Marista de Guadalajara, con experiencia en el diseño, construcción y pruebas de motores cohete de combustible sólido y lanzamiento de cohetes experimentales. Recientemente, impartió la ponencia <b>La cohetería experimental como medio para fomentar el estudio y la aplicación de las ciencias</b> en la <b>Pasarela Tecnológica 2024</b>",
  },
  {
    id: 8,
    name: "Ing. Laura Zimmermannn Soto",
    title: "Simulación y Diseño Mecánico",
    image: imageIndex.JuezIngLaura,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/laura-zimmermann-005626224/",
    },
    bio: "<b> Laura Zimmermann </b> es ingeniera en Mecatrónica con experiencia en automatización industrial, control de sistemas y tecnología aeroespacial. Ha colaborado con la Agencia Espacial Mexicana en simulaciones satelitales y organización de FAMEX, y realizó una estancia de investigación en el CINVESTAV enfocada en sistemas fotovoltaicos. Fue líder del equipo <b>Milvus Rocket</b> de la UPAEP, con el que obtuvo el primer lugar en el concurso nacional <b>ENMICE 2024</b>, destacando en el diseño y lanzamiento de cohetes de combustible sólido. Su trayectoria combina liderazgo técnico, participación en foros especializados y desarrollo de proyectos con enfoque aeroespacial. \n\n Multilingüe, domina el español, inglés y alemán, y ha desarrollado competencias técnicas en plataformas como STK, SAP y metodologías DMAIC. Su perfil combina liderazgo, habilidades técnicas y visión internacional en el sector aeroespacial y tecnológico.",
  },
  {
    id: 9,
    name: "Mtro. Eduardo Velázquez Mora",
    title: "Electrónica y Cargas Útiles",
    image: imageIndex.JuezMtroEduardo,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/eduardo-velazquez-mora-5878a955/",
    },
    bio: "Ingeniero en Comunicaciones y Electrónica con Maestría en Sistemas de Calidad, el Mtro. Eduardo Velázquez Mora cuenta con más de 20 años de experiencia en docencia, investigación y gestión de proyectos tecnológicos. Profesor de tiempo completo en CUCEI, ha liderado iniciativas clave como Radio CUCEI y el Concurso CanSat CUCEI, este último con gran impacto en la formación de talento para el sector aeroespacial en México.\n\n Especialista en electrónica, diseño digital y aseguramiento de calidad, ha trabajado en la industria de manufactura electrónica, así como en la implementación de sistemas de gestión de calidad bajo normas internacionales. Su enfoque educativo se distingue por fomentar la innovación, el trabajo interdisciplinario y el desarrollo de habilidades estratégicas. \n\n Es miembro activo del Consejo de Transformación Digital de Jalisco y ha colaborado con asociaciones dedicadas a la tecnología y la comunicación. Su trayectoria refleja un compromiso constante con la excelencia académica, la transformación digital y el impulso al desarrollo tecnológico en el país.",
  },
  {
    id: 10,
    name: "Mtro. Gustavo García Rojas",
    title: "Operaciones Aeronáuticas",
    image: imageIndex.JuezMtroGustavo,
    socialLinks: {
      linkedin: "#",
    },
    bio: "Ingeniero en Aeronáutica por la ESIME Ticomán del Instituto Politécnico Nacional (IPN) y Maestro en Ciencias en Ingeniería Mecánica con especialidad en diseño, el Mtro. Gustavo Rojas cuenta con más de 25 años de trayectoria en el ámbito aeronáutico, destacándose por su labor en docencia, capacitación técnica, certificación de aeronaves y divulgación especializada. Desde 1999 es profesor en la ESIME Ticomán, donde ha impartido materias como Legislación Aeronáutica, Ingeniería de Operaciones y Navegación Aérea; también fue docente en el ITESM de 2015 a 2020. Ha colaborado en proyectos de certificación de aeronaves con empresas como Oaxaca Aerospace, Quetzal Aeroespacial y Aztecawind, además de formar parte de múltiples iniciativas académicas, técnicas y legislativas. Es autor de la reconocida <b> Serie Aerotécnica </b>, una colección de libros técnicos ampliamente utilizados en la formación aeronáutica en México, y ha participado como ponente en diplomados internacionales organizados por el IPN y la OACI. \n\n Su experiencia incluye la dirección operativa de un taller de mantenimiento de helicópteros, la formación de personal técnico en aviación y la traducción de textos especializados. Practica paracaidismo deportivo desde 1992 y actualmente es presidente de la Asociación Nacional de Paracaidismo Deportivo. Su enfoque integral combina la excelencia técnica con la pasión por la enseñanza y el desarrollo del sector aeronáutico nacional.",
  },
  {
    id: 11,
    name: "Ing. Dante Delgado Ávalos",
    title: "Operaciones, Simulación y Diseño Mecánico",
    image: imageIndex.JuezIngDante,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/dante-delgado-7a2832231/",
    },
    bio: "Dante Delgado es ingeniero mecánico con experiencia en cohetería experimental, diseño estructural y manufactura avanzada. \n\n Ha liderado proyectos de desarrollo tecnológico en competencias como ENMICE y Spaceport America Cup, donde formó parte del primer equipo mexicano en completar una misión exitosa. Actualmente es cofundador de THORLIFT, empresa dedicada al desarrollo de drones tripulados, y dirige Visions in Common, enfocada en soluciones de manufactura digital e impresión 3D industrial. Su trabajo combina ingeniería aplicada, emprendimiento e innovación con una visión de impacto nacional e internacional.",
  },
  {
    id: 12,
    name: "Ing. Luis Francisco Rodríguez Jiménez",
    title:
      "Ingeniería Mecánica y de Sistemas, Procesos Regulatorios y Desarrollo Comercial",
    image: imageIndex.JuezIngLuisFrancisco,
    socialLinks: {
      linkedin:
        "https://www.linkedin.com/in/luis-francisco-rodríguez-jiménez-a4ab8a55/",
    },
    bio: "El Ingeniero Luis Francisco Rodríguez Jiménez es egresado del Instituto Politécnico Nacional por la carrera de Ingeniería Aeronáutica. Realizó estudios pre facultativos en la Federación Rusa en el 2002 y destaca la participación de una estancia en la Universidad Aeroespacial de Kharkov (Járkov) en Ucrania, donde realizó estudios experimentales en túneles de viento y prácticas en aerodinámica. Posteriormente, inició sus estudios de Maestría en Ingeniería Mecánica en la Sección de Estudios de Posgrado e Investigación de la ESIME Zacatenco. \n\n En 2012 se une al equipo de trabajo del Sistema Satelital Mexicano MEXSAT, en donde comienza su carrera profesional desempeñándose como Analista de Dinámica Orbital para los satélites Mexsat-3 y Mexsat-2. Participó en los procesos de adquisición de los vehículos lanzadores Proton-M y Atlas V-421. Atendió las operaciones de misión del Mexsat-3 “Bicentenario” en Dulles, Virginia, así como la campaña de lanzamiento del Mexsat-1 “Centenario” en el cosmódromo de Baikonur, Kazajistán. Fue el representante de la Secretaría de Comunicaciones y Transportes para el peritaje de dos misiones fallidas del lanzador Proton-M, en Moscú – Federación Rusa. \n\n Trabajó como Gerente de Comercialización en la Agencia Espacial Mexicana en el periodo de 2016 a 2025, donde, bajo la dirección de la Coordinación General de Desarrollo Industrial, Comercial y Competitividad, implementó programas para articular la cadena de valor. Dentro de los logros alcanzados destaca: \n\n  <li>El Secretariado Técnico del Comité Técnico de Normalización Nacional del Espacio, en donde se publicaron a la fecha tres normas mexicanas espaciales.</li>   <li>Participó en el desarrollo conceptual del laboratorio de cohetes del Centro Regional de Innovación y Desarrollo del Estado de México.</li> <li> Seguimiento al proceso regulatorio de los puertos de lanzamiento y permisos para vehículos lanzadores en territorio nacional.</li> <li>Promoción y atracción de empresas lanzadoras internacionales para ubicarse en territorio nacional.</li> <li>Participación en el Programa UniSpace Nanosatellite Assembly and Integration Training (UNNATI), conducido por la Agencia India de Investigación Espacial (ISRO) en Bengaluru, India en 2022.</li> <li>Firma de convenio y desarrollo del Estudio de Factibilidad para sitios de lanzamiento en territorio nacional con el Instituto de Investigación Aeroespacial de Corea (KARI).</li>",
  },
];

const SpeakerCard = ({ speaker }) => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: 16,
    transition: theme.transitions.create(["transform", "box-shadow"], {
      duration: theme.transitions.duration.standard,
    }),
  }));

  const StyledAvatar = styled(Avatar)(({ theme }) => ({
    width: "100%",
    height: 192,
    marginBottom: theme.spacing(3),
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.standard,
    }),
    "&:hover": {
      transform: "scale(1.05)",
    },
    "& img": {
      objectFit: "cover",
      objectPosition: "center",
    },
    [theme.breakpoints.down("sm")]: {
      objectFit: "cotain",
      // Add mobile-specific adjustments
      marginTop: theme.spacing(4), // Move the avatar down a bit
      height: 280,
    },
  }));

  return (
    <>
      <Box
        sx={{
          cursor: "pointer",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          border: 1,
          borderRadius: 1,
          borderColor: "#777777ff",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          background: "none",
        }}
      >
        <StyledCard sx={{ height: "100%" }}>
          <CardContent
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Avatar - fixed height */}
            <Box
              sx={{
                position: "relative",
                mb: 1,
                height: 192,
                flexShrink: 0,
                [theme.breakpoints.down("sm")]: {
                  height: 280,
                },
              }}
            >
              <StyledAvatar
                src={speaker.image}
                alt={speaker.name}
                variant="rounded"
                sx={{
                  width: "100%",
                  height: "100%",
                  [theme.breakpoints.down("sm")]: {
                    marginTop: "5px",
                  },
                }}
              />
            </Box>

            {/* Text content - grows to fill space */}
            <Box
              sx={{
                textAlign: "center",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    color: "text.primary",
                    "&:hover": { color: "primary.main" },
                    transition: "color 0.3s",
                    minHeight: "3em",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {speaker.name}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "text.primary",
                    mb: 1,
                    lineHeight: 1.4,
                  }}
                >
                  Especialidad
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    mb: 2,
                    lineHeight: 1.6,
                    minHeight: "3em",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {speaker.title}
                </Typography>
              </Box>

              {/* LinkedIn button and bio trigger */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  mt: "auto",
                }}
              >
                {speaker.socialLinks.linkedin && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      pt: 2,
                    }}
                  >
                    <IconButton
                      href={speaker.socialLinks.linkedin}
                      size="small"
                      sx={{
                        bgcolor: "background.paper",
                        color: "text.secondary",
                        "&:hover": {
                          bgcolor: "primary.main",
                          color: "common.white",
                          transform: "scale(1.1)",
                        },
                        transition: "all 0.3s",
                      }}
                    >
                      <LinkedIn fontSize="small" />
                    </IconButton>
                  </Box>
                )}

                {!isMobile && (
                  <Button
                    onClick={handleOpen}
                    sx={{
                      textTransform: "none",
                      color: "text.secondary",
                      fontSize: "0.75rem",
                      p: 0,
                      mt: 1,
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "primary.main",
                      },
                    }}
                  >
                    Ver semblanza
                  </Button>
                )}
              </Box>
            </Box>
          </CardContent>
        </StyledCard>
      </Box>

      {/* Bio Modal */}

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        PaperProps={{
          sx: {
            border: 1,
            borderColor: "#777777ff",
            borderRadius: 2,
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            backgroundImage: "none",
            backgroundColor: theme.palette.background.paper,
            // More aggressive size constraints
            width: { xs: "85vw", sm: "90vw", md: "80vw" },
            maxWidth: 900,
            height: { xs: "150vw", sm: "180vw", md: "200vw" },
            maxHeight: "85vh",
            mx: "auto",
            my: "auto",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            pt: 4,
            position: "relative",
            pb: 2,
            flexShrink: 0,
          }}
        >
          <Avatar
            src={speaker.image}
            alt={speaker.name}
            sx={{
              width: { xs: 80, sm: 120 },
              height: { xs: 80, sm: 120 },
              mx: "auto",
              mb: 1,
            }}
          />
          <Typography variant="h5" component="div" sx={{ fontWeight: "bold" }}>
            {speaker.name}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            {speaker.title}
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent
          sx={{
            py: 1,
            px: { xs: 2, sm: 4 },
            overflow: "auto",
            flex: 1,

            scrollbarWidth: "thin",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: theme.palette.action.disabled,
              borderRadius: "3px",
            },
          }}
        >
          <Typography
            variant="body1"
            paragraph
            sx={{
              color: theme.palette.text.primary,
              whiteSpace: "pre-line",
              "& b": {
                fontWeight: "bold",
              },
              overflowWrap: "break-word",
              wordBreak: "break-word",
              fontSize: { xs: "0.9rem", sm: "1rem" }, // Slightly smaller text on mobile
            }}
            dangerouslySetInnerHTML={{ __html: speaker.bio }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

const CommitteeSection = () => {
  return (
    <Box sx={{ py: 15, px: 2, maxWidth: "lg", mx: "auto" }}>
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Typography
          variant="h3"
          component="h2"
          sx={{ fontWeight: "bold", mb: 2, color: "text.primary" }}
        >
          Cómite Evaluador
        </Typography>
        <Box
          sx={{ width: 96, height: 4, bgcolor: "primary.main", mx: "auto" }}
        />
      </Box>

      <Grid container spacing={4}>
        {speakersData.map((speaker) => (
          <Grid item key={speaker.id} xs={12} sm={6} lg={2.4}>
            <SpeakerCard speaker={speaker} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CommitteeSection;
